module.exports = __webpack_public_path__ + "static/media/profil.c679dcf6.png";